import { notifyTrackingDebug } from "~/utils/tracking-debug";

const firebaseConfig = {
	apiKey: "AIzaSyBqKwOylw6nU_71dXTNOO9XscZsXX1e2Gg",
	authDomain: "seeronnet-dabbb.firebaseapp.com",
	projectId: "seeronnet-dabbb",
	storageBucket: "seeronnet-dabbb.appspot.com",
	messagingSenderId: "123186216221",
	appId: "1:123186216221:web:c773567b81235d356275f4",
	measurementId: "G-GC3R5X4WVK",
};
let initPromise = null;
let analytics = null;
let logEventFn = null;
const pendingEvents = [];

function dispatchLogEvent({ eventName, eventParams, options }) {
	if (!analytics || !logEventFn) return;

	try {
		const channel = typeof localStorage !== "undefined" ? localStorage.getItem("channel") : null;
		const mergedParams = {
			...(channel ? { channel } : {}),
			...eventParams,
		};

		logEventFn(analytics, eventName, mergedParams, options);
		notifyTrackingDebug({ eventName, eventParams: mergedParams });
	} catch (error) {
		console.error("Firebase logEvent error:", error);
	}
}

function flushPendingEvents() {
	if (!analytics || !logEventFn) return;

	while (pendingEvents.length) {
		dispatchLogEvent(pendingEvents.shift());
	}
}

function initFirebase() {
	if (!import.meta.client) return Promise.resolve(null);

	if (!initPromise) {
		initPromise = Promise.all([import("firebase/app"), import("firebase/analytics")])
			.then(([{ initializeApp }, { getAnalytics, setUserProperties, logEvent }]) => {
				try {
					const app = initializeApp(firebaseConfig);
					analytics = getAnalytics(app);
					logEventFn = logEvent;

					const APP_VERSION = process.env.APP_VERSION || "1.0.0";
					setUserProperties(analytics, {
						version: APP_VERSION,
					});
					console.log("Firebase 初始化成功");
					flushPendingEvents();
				} catch (error) {
					console.error("Firebase 初始化失败:", error);
					initPromise = null;
				}

				return analytics;
			})
			.catch(error => {
				console.error("Firebase 加载失败:", error);
				initPromise = null;
				return null;
			});
	}

	return initPromise;
}

/** 浏览器空闲时预加载 Firebase SDK（独立 chunk，不阻塞首屏 JS） */
export function preloadFirebase() {
	return initFirebase();
}

/**
 * Firebase埋点上报方法
 * @param {string} eventName 事件ID
 * @param {Object} [eventParams] 事件参数
 * @param {Object} [options] 可选参数
 */
export function logEvent(eventName, eventParams = {}, options = {}) {
	if (!import.meta.client) return;

	const payload = { eventName, eventParams, options };

	if (analytics && logEventFn) {
		dispatchLogEvent(payload);
		return;
	}
	pendingEvents.push(payload);
	initFirebase();
}

export { analytics };
